/**
 * Adapter para la librería de Drag and Drop
 * 
 * ÚNICO ARCHIVO que importa directamente de @dnd-kit
 * Si se cambia de librería, solo modificar este archivo
 * 
 * Este adapter centraliza todas las dependencias de @dnd-kit para facilitar
 * migraciones futuras. Todos los componentes DnD deben importar desde aquí
 * en lugar de directamente desde @dnd-kit.
 */

// ===== HOOKS =====
import { useSortable as useSortableDndKit } from '@dnd-kit/sortable';
import { 
  useDraggable as useDraggableDndKit,
  useDroppable as useDroppableDndKit,
  useSensor as useSensorDndKit,
  useSensors as useSensorsDndKit,
  useDndContext as useDndContextDndKit,
} from '@dnd-kit/core';

export const useSortable = useSortableDndKit;
export const useDraggable = useDraggableDndKit;
export const useDroppable = useDroppableDndKit;
export const useSensor = useSensorDndKit;
export const useSensors = useSensorsDndKit;
export const useDndContext = useDndContextDndKit;

// ===== COMPONENTES =====
import { 
  DndContext as DndContextDndKit,
  DragOverlay as DragOverlayDndKit,
} from '@dnd-kit/core';
import { SortableContext as SortableContextDndKit } from '@dnd-kit/sortable';

export const DndContext = DndContextDndKit;
export const DragOverlay = DragOverlayDndKit;
export const SortableContext = SortableContextDndKit;

// ===== UTILIDADES =====
import { CSS as CSSDndKit } from '@dnd-kit/utilities';

export const CSS = CSSDndKit;

// ===== SENSORES =====
import { 
  PointerSensor as PointerSensorDndKit,
  KeyboardSensor as KeyboardSensorDndKit,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates as sortableKeyboardCoordinatesDndKit } from '@dnd-kit/sortable';

export const PointerSensor = PointerSensorDndKit;
export const KeyboardSensor = KeyboardSensorDndKit;
export const sortableKeyboardCoordinates = sortableKeyboardCoordinatesDndKit;

// ===== DETECCIÓN DE COLISIONES =====
import {
  closestCenter as closestCenterDndKit,
  pointerWithin as pointerWithinDndKit,
  rectIntersection as rectIntersectionDndKit,
} from '@dnd-kit/core';

export const closestCenter = closestCenterDndKit;
export const pointerWithin = pointerWithinDndKit;
export const rectIntersection = rectIntersectionDndKit;

// ===== ESTRATEGIAS DE ORDENAMIENTO =====
import {
  horizontalListSortingStrategy as horizontalListSortingStrategyDndKit,
  verticalListSortingStrategy as verticalListSortingStrategyDndKit,
} from '@dnd-kit/sortable';

export const horizontalListSortingStrategy = horizontalListSortingStrategyDndKit;
export const verticalListSortingStrategy = verticalListSortingStrategyDndKit;
